class Adventure {
  currentLevel;

  constructor(world, stage) {
    this.world = world;
    this.visitedLevels = new Map();
    this.log = [];
  }

  appendLog(message) {
    this.log.unshift(message);
  }

  startLevel() {
    return this.world.spawnStartLevel();
  }

  spawnLevel(id) {
    return this.world.spawnLevel(id);
  }

  hasVisited(id) {
    return this.visitedLevels.has(id);
  }

  saveLevel(id, snapshot) {
    this.visitedLevels.set(id, snapshot);
  }

  restoreLevel(id) {
    return this.visitedLevels.get(id);
  }

  getLevel(id) {
    return this.world.getLevel(id);
  }
}

export default Adventure;
